export default __webpack_public_path__ + "images/spinner-solid-white.cc2a76354f1873bf0899883f274bc97f.png";